import { SkeletonElement } from './SkeletonElement/SkeletonElement';
import { hstack, stack } from '@bts-web/utils-style-engine';

type PriceSkeletonProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
};

type CircleSkeletonProps = {
  showPriceSkeleton?: boolean;
};

const CircleSkeleton = () => (
  <SkeletonElement width="medium" height="medium" borderRadius="30px" />
);

const PriceSkeleton = ({
  width = '103px',
  height = '20px',
  borderRadius = '30px',
}: PriceSkeletonProps) => (
  <SkeletonElement width={width} height={height} borderRadius={borderRadius} />
);

export const CellSkeleton = ({
  showPriceSkeleton = true,
}: CircleSkeletonProps) => (
  <div
    className={stack({
      gap: 'small',
      padding: 'medium',
      width: '100%',
    })}
    data-testid="transaction-item-skeleton-container"
  >
    <div className={hstack({ justifyContent: 'space-between' })}>
      <div className={hstack()}>
        <CircleSkeleton />
        <div className={stack()}>
          <PriceSkeleton />
          <SkeletonElement
            width="extra_large_4"
            height="medium"
            borderRadius="30px"
          />
        </div>
      </div>

      <div className={hstack()}>
        <div className={stack()}>
          {showPriceSkeleton && <PriceSkeleton />}
          <PriceSkeleton />
        </div>

        <CircleSkeleton />
      </div>
    </div>
  </div>
);
